var _desc, _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of the Philippines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coding according to the official \"description and specification of the FILIPINO flag\" in Executive Order No. 23 from 1936")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 90,
    fill: "#0038a8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 180,
    height: 45,
    fill: "#ce1126"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 77.942286,45 0,90 0,0",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28,45)",
    fill: "#fcd116"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z",
    transform: "scale(19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z",
    transform: "scale(19.238092)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "scale(1,-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.019238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "translate(37.961524,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(1,-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(-120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.beb5ee035e68b026702a02922caa8290.svg";
export { ForwardRef as ReactComponent };